import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js"

export default class extends Controller {
  static values = {backdrop: {type: Boolean, default: true}};
  static targets = ["askCancelButton", "button", "invalidMessage", "dialog", "input", "submitButton"];

  connect() {
    console.debug("Gym Payments connected");
    this.modal = bootstrap.Modal.getOrCreateInstance(this.dialogTarget, {
      backdrop: this.backdropValue ? "static" : false,
      keyboard: false
    });

    this.selectedSchedules = [];
  }

  disconnect() {
    console.debug("Gym Payments disconnected");
  }

  open(e) {
    if (!this.modal.isOpened) {
      this.modal.show();

      this.dialogTarget.addEventListener("shown.bs.modal", () => {
        this.inputTarget.focus();
      }, {once: true});
    }
  }

  hide() {
    this.invalidMessageTarget.classList.remove('d-block');
    this.inputTarget.value = "";
    this.modal.hide();
  }

  close(event) {
    if (event.detail.success) {
      this.modal.hide();
    }
  }

  askPin(event) {
    console.debug(event, this.dialogTarget);
    this.open();
  }

  submit(event) {
    event.preventDefault();
    this.submitButtonTarget.setAttribute("disabled", "disabled");
    this.submitButtonTarget.children[1].textContent = "Verificando ...";
    this.invalidMessageTarget.classList.remove('d-block');

    const pin = event.target.pin.value;

    get(`/g/payments/check_pin?pin=${pin}`, {responseKind: "json"}
    ).then(response => {
      console.debug("CANCEL MANY RESPONSE", response);

      this.submitButtonTarget.children[1].textContent = "Verificar";
      this.submitButtonTarget.removeAttribute("disabled");

      if (!response.ok) {
        return false;
      }

      return response.json;
    }).then(result => {
      console.debug("=> PIN REsult", result)

      if (result) {
        this.hide();
        this._enableButtons();
      } else {
        this.invalidMessageTarget.classList.add('d-block');
        this._disableButtons();
      }
    });
  }

  _enableButtons() {
    for (const buttonTarget of this.buttonTargets) {
      buttonTarget.removeAttribute("disabled");
    }
  }

  _disableButtons() {
    for (const buttonTarget of this.buttonTargets) {
      buttonTarget.setAttribute("disabled", "disabled");
    }
  }

}
